








































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { VersionString } from '@/constants/environment';

@Component({})
export default class ResetPassword extends Vue
{
	passwordInputType : string = "password";
	attemptingSubmit : boolean = false;
	redirect : any = "/";
	errors : any[] = [];
	formData : any = 
	{
	    email: "",
	    password: ""
	};

	clickPasswordInputType()
	{
	    if(this.passwordInputType == "password")
	    {
	        this.passwordInputType = "text";
	    }
	    else
	    {
	        this.passwordInputType = "password";
	    }
	}

	keypress(evt : any)
	{
	    // form submit doesn't seem to work here for some reason,
	    // so we just listen for keypress w/ Enter 
	    if (evt.key == "Enter")
	    {
	        this.clickSubmit();
	    }
	}

	async clickSubmit()
	{
	    this.errors.length = 0;
	    this.redirect = this.$route.query.redirect || this.redirect;
	    this.attemptingSubmit = true;
	    let form = new FormData();
	    form.append('email', this.formData.email);
	    form.append('newPass', this.formData.password);
		
	    try 
	    {
	        let res = await this.$http.post('forgotpassword', form);
	        if (res.data.error)
	        {
	            this.errors.push({ message: res.data.error, variant:"danger" });
	            this.attemptingSubmit = false;
	            return;
	        }
	        alert(res.data.result);
	        this.$router.push('/login');
	    } 
	    catch (error) 
	    {
	        let res = error.response;
	        if (res.data.error)
	        {
	            this.errors.push({ message: res.data.error, variant:"danger" });
	            this.attemptingSubmit = false;
	            return;
	        }
	    }
	    this.attemptingSubmit = false;
	}

	clickCancel()
	{
	    this.$router.push('/login');
	}

	get VersionString() 
	{
	    return VersionString; 
	}
}
